import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

import App from '@/App.vue';
import CoreSidebar from '@/components/Core/CoreSidebar.vue';
import router from '@/router';
import store from '@/store';
import VueMeta from 'vue-meta';
import vSelect from 'vue-select';
import VueTheMask from 'vue-the-mask';
import VueScrollTo from 'vue-scrollto';
// Bootstrap 5.3 (the Talentspace design is built on it); BootstrapVue stays only for its components' behaviour
import '@/assets/scss/bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'vue-select/dist/vue-select.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// Legacy portal styles, still used by the screens that are not redesigned yet
import '@/assets/scss/main.scss';
// Talentspace design system: untouched design export + the per-site token bridge
import '@/assets/talentspace/ts-talentspace.css';
import '@/assets/talentspace/site-theme.css';
import '@/assets/talentspace/widgets.scss';
// Our fixes on top of the design (narrow screens, long labels)
import '@/assets/talentspace/fixes.scss';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueScrollTo);
Vue.component('v-select', vSelect);
Vue.component('core-sidebar', CoreSidebar);

Vue.config.productionTip = false;

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

Vue.use(VueTheMask);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
